import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import { allFeatureTogglesLoaded, initializeModule, loadAllFeatureToggles } from '../actions/feature-toggles.actions';
import { FeatureTogglesService } from '../services/feature-toggles.service';

@Injectable()
export class GenesysCloudFeatureTogglesEffects {
  readonly init$ = createEffect(() => this.actions$.pipe(
    ofType(initializeModule),
    map(() => loadAllFeatureToggles())
  ));

  readonly loadAllFeatureToggles$ = createEffect(() => this.actions$.pipe(
    ofType(loadAllFeatureToggles),
    mergeMap(() => this.featureTogglesService.loadAllFeatureToggles()),
    map(featureToggles => allFeatureTogglesLoaded({ featureToggles }))
  ));

  constructor(private readonly actions$: Actions,
              private readonly featureTogglesService: FeatureTogglesService
  ) {}
}
